import script from "./BlockFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockFilter.vue?vue&type=script&setup=true&lang=js"

import "./BlockFilter.vue?vue&type=style&index=0&id=7f01dbdd&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f01dbdd"]])

export default __exports__